import { alpha } from '@mui/material/styles';
import { common } from '@mui/material/colors';
import { brand, neutral, statusTone } from '../../theme';

/**
 * Colours for the multicam players' dark surfaces, built from the theme so no
 * component hard-codes a hex value. Every text tone keeps at least 6:1 on the
 * near-black transport and stage (white at 55% is 6.1:1 on the transport).
 */
export const playerTokens = {
  /** The picture area behind a video. */
  stage: common.black,
  /** Labels and badges laid over the picture. */
  overlay: alpha(brand.ink, 0.8),
  text: common.white,
  /** Secondary text on dark: 7.4:1 or better. */
  textMuted: alpha(common.white, 0.72),
  /** Unavailable controls: still 6:1, so they stay readable. */
  textDisabled: alpha(common.white, 0.55),
  border: alpha(common.white, 0.28),
  borderStrong: alpha(common.white, 0.55),
  hover: alpha(common.white, 0.1),
  /** The angle a creator's cut shows at the playhead. */
  live: brand.green,
  focus: common.white,
} as const;

/**
 * One colour per camera angle, used by the annotator's angles lane, the cut
 * markers and the review player. White labels keep 4.9:1 or better on each,
 * and none of them is copper (reserved for actions).
 */
// Six angles, six colours: indigo and purple keep white labels at 7:1 or more.
const ANGLE_COLORS = [brand.slate, brand.teal, statusTone.attention.main, neutral[700], '#4338CA', '#7E22CE'] as const;

export const angleColor = (angleKey?: string | null): string => {
  const key = String(angleKey || '').trim().toUpperCase();
  const index = key.length === 1 && key >= 'A' && key <= 'Z' ? key.charCodeAt(0) - 65 : 0;
  return ANGLE_COLORS[index % ANGLE_COLORS.length];
};
